const doc = [({"da":({"js":({"admin":({"photo_qualities":({"create_card":({"create_photo_quality":"Opret fotokvalitet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;